import { render } from "./CertificationModel.vue?vue&type=template&id=49b6188e&scoped=true&ts=true"
import script from "./CertificationModel.vue?vue&type=script&lang=ts"
export * from "./CertificationModel.vue?vue&type=script&lang=ts"

import "./CertificationModel.vue?vue&type=style&index=0&id=49b6188e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b6188e"]])

export default __exports__